/*
 * modal-guard.js
 *
 * Safety net for the overlay modals. The bug it guards against:
 * a modal is made click-absorbing (pointer-events enabled) in one step and
 * faded in (opacity 0 -> 1) in another. If the fade step is skipped or delayed
 * - which is what happens when the opening is scheduled inside a
 * requestAnimationFrame while the browser tab is in the background - the modal
 * ends up fully transparent AND intercepting every click. The page looks
 * completely normal but nothing on it responds: no links, no Add to cart.
 *
 * modals.js now opens modals in the correct order, so on an up-to-date theme
 * this file never has to do anything. It stays as a guard because the failure
 * is silent, indistinguishable from "the site is broken", and costs sales.
 */
(function () {
    "use strict";

    function isInvisible(el) {
        var opacity = parseFloat(getComputedStyle(el).opacity);
        return !isNaN(opacity) && opacity <= 0.01;
    }

    function isArmed(el) {
        return (
            !el.classList.contains("pointer-events-none") &&
            getComputedStyle(el).pointerEvents !== "none"
        );
    }

    function disarm(el) {
        el.classList.add("pointer-events-none", "opacity-0");
        el.classList.remove("opacity-100");
        el.setAttribute("aria-hidden", "true");
    }

    function modals() {
        return document.querySelectorAll("[id$='-modal']");
    }

    // Catch a click that is about to be eaten by an invisible overlay, stand the
    // overlay down, and hand the click to whatever the shopper actually aimed at.
    document.addEventListener(
        "click",
        function (e) {
            var overlay = e.target.closest && e.target.closest("[id$='-modal']");
            if (!overlay || !isArmed(overlay) || !isInvisible(overlay)) return;

            disarm(overlay);

            var beneath = document.elementFromPoint(e.clientX, e.clientY);
            if (!beneath) return;
            var link = beneath.closest && beneath.closest("a[href], button");
            if (link) {
                e.preventDefault();
                e.stopPropagation();
                link.click();
            }
        },
        true,
    );

    // Sweep on the events most likely to follow a missed fade-in.
    function sweep() {
        Array.prototype.forEach.call(modals(), function (el) {
            if (isArmed(el) && isInvisible(el)) disarm(el);
        });
    }

    document.addEventListener("visibilitychange", function () {
        if (!document.hidden) setTimeout(sweep, 400);
    });
    window.addEventListener("pageshow", function () {
        setTimeout(sweep, 400);
    });
})();
